const React = require('react');
import receiveCoupons from '../../asset/images/weixinPackImg/receive-coupons.png';
import '../../asset/style/style.scss';
import './receive-coupons.scss';
import config from '../../../src/config.js';
import { CouponEntry } from '../../helper/const.js';
import { createReceivedCouponMgr, createShareCouponMgr } from '../../helper/storage-pair-helper.js';
import FormattedMessage from '@/intl/formatted-message';
import globalMessages from '../../intl/messages/global';

const commonHelper = require('../../helper/common-helper.js');

const shopId = commonHelper.getUrlParam('shopId');
const type = commonHelper.getUrlParam('type');
const orderCoupon = commonHelper.getUrlParam('orderId');
const receivedCoupon = createReceivedCouponMgr();
const receivedCouponValue = receivedCoupon.get();
const sharedCouponValue = createShareCouponMgr().get();

module.exports = React.createClass({
  displayName: 'ReceiveCoupons',
  propTypes: {
    handleClose: React.PropTypes.func,
    couponList: React.PropTypes.array,
    couponType: React.PropTypes.number,
    getCoupons: React.PropTypes.func,
    shopInfo: React.PropTypes.object,
    isShowAlreadyGotCoupon: React.PropTypes.bool,
    linkUrl: React.PropTypes.string,
  },

  defaultProps: {
    linkUrl: config.getCouponListURL,
    couponList: [],
  },

  getInitialState() {
    return {
      showCouponList: true,
    };
  },

  handleClick(e, coupId) {
    if (e) {
      e.preventDefault();
    }

    const { getCoupons, couponType } = this.props;
    const { isOldMarketing, couponList = [] } = this.props.shopInfo;

    if (couponType === CouponEntry.DISHDETAIL) {
      // 如果是从结算后页面过来
      location.href = `/coupon/getCouponList?shopId=${shopId}`;
    } else if (couponType === CouponEntry.DISH) {
      if (isOldMarketing) {
        // 老逻辑
        getCoupons(coupId, () => this.handleClose(null, coupId));
      } else {
        // 新逻辑
        getCoupons(couponList[0].coupId, () => this.handleClose(null));
      }
    }
  },

  handleClose(e, coupId) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const { shopInfo, couponType, handleClose } = this.props;
    const { ruleId, planId, isOldMarketing } = shopInfo || {};

    if (couponType === CouponEntry.DISHDETAIL || couponType === CouponEntry.RECEIVED) {
      if (handleClose) {
        handleClose();
      }

      this.defaultCloseEvent();
      return;
    }

    if (isOldMarketing) {
      // 老逻辑
      const alreadySendCouponOld = localStorage.alreadySendCouponOld || '';
      const stuff = `${type}_${shopId}_${coupId}`;
      if (alreadySendCouponOld.indexOf(stuff) === -1) {
        localStorage.alreadySendCouponOld = (localStorage.alreadySendCouponOld || '') + stuff + ',';
      }
    } else {
      // 新逻辑
      const alreadySendCouponNew = localStorage.alreadySendCouponNew || '';
      const stuff = `${type}_${shopId}_${ruleId}_${planId}`;
      if (alreadySendCouponNew.indexOf(stuff) === -1) {
        localStorage.alreadySendCouponNew = (localStorage.alreadySendCouponNew || '') + stuff + ',';
      }
    }

    this.props.handleClose();
    this.props.getCoupontoGuid(true);
  },

  // 计算优惠券规则
  setCouponValue(marketCoupon = {}) {
    const { ruleId, planId } = this.props.shopInfo || {};
    let spanInfo = '';

    // 1 代金券 2 折扣券 3 礼品券 4 代金券
    // 领券新方案
    if (ruleId && planId) {
      if (marketCoupon.coupType === 1 || marketCoupon.coupType === 4) {
        spanInfo = <span className="o-fz--16 coupons-content__value-money money-after price o-fw--b">{marketCoupon.value}</span>;
      } else if (marketCoupon.coupType === 2) {
        spanInfo = (
          <span className="o-fz--16 coupons-content__value-money o-fw--b">
            {marketCoupon.value}
            <small>
              <FormattedMessage {...globalMessages.discount} />
            </small>
          </span>
        );
      }
    } else {
      // 老方案
      if (marketCoupon.coupType === 1 || marketCoupon.coupType === 4) {
        spanInfo = <span className="o-fz--16 coupons-content__value-money money-after price o-fw--b">{marketCoupon.value}</span>;
      } else if (marketCoupon.coupType === 2) {
        spanInfo = (
          <span className="o-fz--16 coupons-content__value-money o-fw--b">
            {marketCoupon.value}
            <small>
              <FormattedMessage {...globalMessages.discount} />
            </small>
          </span>
        );
      } else if (marketCoupon.coupType === 3) {
        spanInfo = <span className="o-fz--16 coupons-content__value-money o-fw--b">礼品券</span>;
      }
    }
    return spanInfo;
  },

  getCouponItem() {
    const { couponList = [], shopInfo = {} } = this.props;
    let couponArr = [];
    let newCouponList;
    // 新老逻辑交替判断
    if (shopInfo.isOldMarketing) {
      // 老逻辑
      newCouponList = [shopInfo.marketCoupon];
    } else {
      // 新逻辑
      // 新老逻辑交替判断
      if (couponList.length === 0) {
        return false;
      }
      newCouponList = couponList;
    }

    newCouponList.forEach((item = {}, index) => {
      const rule = this.setCouponValue(item);
      couponArr.push(
        <li className="" key={index}>
          <div className="coupons-content">
            <div className="coupons-content__value">
              {rule}
              <span className="o-fz--10 coupons-content__value-text">
                {item.limit ? (
                  <FormattedMessage {...globalMessages.limitValueCanUse} values={{ limitValue: item.limit, currency: sessionStorage.getItem('currency') }} />
                ) : (
                  <FormattedMessage {...globalMessages.useUnlimited} />
                )}
              </span>
            </div>
            <div className="coupons-content__description">
              <span className="o-fz--15 coupons-content__description-title o-fw--b" data-coupons={item.count <= 1 ? '' : `x${item.count}`}>
                {item.name}
              </span>
            </div>
          </div>
        </li>,
      );
    });

    return couponArr;
  },

  defaultLinkEvent() {
    const { clickEvent, linkUrl } = this.props;

    if (clickEvent) {
      clickEvent();
    }

    if (this.props.couponType === CouponEntry.RECEIVED && this.props.couponExit) {
      if (!(receivedCouponValue || {})[orderCoupon]) {
        receivedCoupon.set({ ...receivedCouponValue, [orderCoupon]: true });
      }
    }

    location.href = `${linkUrl || config.getCouponListURL}?shopId=${shopId}&type=${type}`;
  },

  defaultCloseEvent() {
    this.setState({ showCouponList: false });

    if (!(receivedCouponValue || {})[orderCoupon] && orderCoupon) {
      receivedCoupon.set({ ...receivedCouponValue, [orderCoupon]: true });
    }
  },

  render() {
    const { couponType, couponSuccess, shopInfo, isShowAlreadyGotCoupon, title, text, couponList } = this.props;
    const { showCouponList } = this.state;
    const marketCoupon = (shopInfo && shopInfo.marketCoupon) || {};
    let hideElement =
      !showCouponList || !couponList.length || (couponType === CouponEntry.RECEIVED && ((receivedCouponValue || {})[orderCoupon] || !orderCoupon));

    if (this.props.shareTip && !sharedCouponValue) {
      hideElement = true;
    }

    if (hideElement) {
      return null;
    }

    return (
      <div
        className="receive-coupons"
        onTouchTap={e => {
          this.handleClose(e, marketCoupon.coupId);
        }}
      >
        <div className="receive-coupons__container" onTouchTap={e => e.stopPropagation()}>
          <div className="container-head">
            <img src={`${receiveCoupons}` || ''} alt="" className="container-head__bg" />
            <div className="container-head__text o-flex o-flex--column-modify o-flex--align-c o-flex--justify-c">
              <p className="o-fz--20 o-fw--b">{title}</p>
              {text && (
                <p className="o-fz--12" style={{ marginTop: 5 }}>
                  {text}
                </p>
              )}
            </div>
            <span
              className="coupons-close"
              onTouchTap={e => {
                this.handleClose(e, marketCoupon.coupId);
              }}
            >
              &nbsp;
            </span>
          </div>
          <div className="container-content">
            <div className="container-content__box" style={{ height: isShowAlreadyGotCoupon ? '300px' : '' }}>
              <ul className="box-coupons">{this.getCouponItem()}</ul>
            </div>
          </div>
          {couponType === CouponEntry.DISH && (
            <div className="container-btn" style={{ height: isShowAlreadyGotCoupon ? '15px' : '' }}>
              {!isShowAlreadyGotCoupon && (
                <span
                  onTouchTap={e => {
                    this.handleClick(e, marketCoupon.coupId);
                  }}
                >
                  {couponSuccess ? <FormattedMessage {...globalMessages.viewCoupon} /> : <FormattedMessage {...globalMessages.pickCoupon} />}
                </span>
              )}
            </div>
          )}
          {(couponType === CouponEntry.DISHDETAIL || couponType === CouponEntry.RECEIVED) && (
            <div className="container-btn">
              <span
                onTouchTap={e => {
                  this.defaultLinkEvent();
                }}
                className="o-fz--16 o-fw--b"
              >
                {couponType === CouponEntry.RECEIVED ? (
                  <FormattedMessage {...globalMessages.viewReceivedCoupon} />
                ) : (
                  <FormattedMessage {...globalMessages.viewAndPickCoupon} />
                )}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/common/receive-coupons.jsx